import React from 'react';
import {BrowserRouter as Router,Link, Switch,Route} from 'react-router-dom';

let values =[
    {email: "email@something.com"},
    {name: "Jane and Jon Doe"},
    {cardNum: 0},
    {cardNam: "Card Name"},
    {ccv: 0},
    {expDate: 0}
]
let PassedInput = [
    {email: false},
    {name: false},
    {cardNum: false},
    {cardNam: false},
    {ccv: false},
    {expDate: false}
]

let inputHandler=(internalProp,props)=>{
    const checkoutBtn = document.getElementById("checkout-submit");
    if(internalProp.currentTarget.value != ""){
        if(internalProp.currentTarget.name == "email"){
            if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(internalProp.currentTarget.value)){
                if(checkoutBtn.classList.contains("checkout-submit-red")){
                    checkoutBtn.classList.remove("checkout-submit-red");
                    props.stateChange("text", "Checkout Now");
                    values.email = internalProp.currentTarget.value;
                    PassedInput[0] = true;
                }
                else{
                    props.stateChange("text", "Checkout Now");
                    values.email = internalProp.currentTarget.value;
                    PassedInput[0] = true;
                }
            }
            else{
                    props.stateChange("text", "Enter a valid " + internalProp.currentTarget.placeholder);
                    checkoutBtn.classList.add("checkout-submit-red");
                    PassedInput[0] = false;
                
            }
        }
        if(internalProp.currentTarget.name == "cardName" || internalProp.currentTarget.name == "business" ){
            if(checkoutBtn.classList.contains("checkout-submit-red")){
                checkoutBtn.classList.remove("checkout-submit-red");
                props.stateChange("text", "Checkout Now");
            }
                values.email = internalProp.currentTarget.value;
                if(internalProp.currentTarget.name == "cardName"){PassedInput[3] = true;}
                else{PassedInput[1] = true;}
            
        }
        if(internalProp.currentTarget.name == "cardNumber" || internalProp.currentTarget.name == "ccv" || internalProp.currentTarget.name == "expDate"){
            if(internalProp.currentTarget.value.match(/^[0-9\-\/]+$/)){
                if(internalProp.currentTarget.name == "cardNumber" ){
                    if(internalProp.currentTarget.value.length > 15 && internalProp.currentTarget.value.length < 21){
                        if(checkoutBtn.classList.contains("checkout-submit-red")){
                            checkoutBtn.classList.remove("checkout-submit-red");
                        }

                        props.stateChange("text", "Checkout Now");
                        values.cardNum = internalProp.currentTarget.value;
                        PassedInput[2] = true; 
                    }

                    else{
                        props.stateChange("text", internalProp.currentTarget.placeholder + " Has the wrong amount of digits");
                        checkoutBtn.classList.add("checkout-submit-red");
                        values.cardNum = internalProp.currentTarget.value;
                        PassedInput[2] = false; 
                    }
                    
                }
                
                else if(internalProp.currentTarget.name == "ccv" ){
                    if(internalProp.currentTarget.value.length > 2 && internalProp.currentTarget.value.length < 5){
                        if(checkoutBtn.classList.contains("checkout-submit-red")){
                            checkoutBtn.classList.remove("checkout-submit-red"); 
                        }

                        props.stateChange("text", "Checkout Now");
                        values.ccv = internalProp.currentTarget.value;
                        PassedInput[4] = true;
                        
                    
                        
                    }
                    else{
                        props.stateChange("text", internalProp.currentTarget.placeholder + " Is missing numbers.");
                        checkoutBtn.classList.add("checkout-submit-red");
                        values.ccv = internalProp.currentTarget.value;
                        PassedInput[4] = false;
                    }
                }
                
                else if(internalProp.currentTarget.name == "expDate"){
                    if(internalProp.currentTarget.value.length == 5){
                        if(checkoutBtn.classList.contains("checkout-submit-red")){
                            checkoutBtn.classList.remove("checkout-submit-red");
                            
                        }
                        props.stateChange("text", "Checkout Now");
                        values.expDate = internalProp.currentTarget.value;
                        PassedInput[5] = true;
                    }
                    else{
                        props.stateChange("text", internalProp.currentTarget.placeholder + " Is missing numbers.");
                        checkoutBtn.classList.add("checkout-submit-red");
                        PassedInput[internalProp.currentTarget.name] = false;
                        //console.log(PassedInput[internalProp.currentTarget.name]);
                    }
                }
                
            }
            else {
                props.stateChange("text", internalProp.currentTarget.placeholder + " Must be only numbers");
                checkoutBtn.classList.add("checkout-submit-red");
            }
        }
    }
    else {
        props.stateChange("text", internalProp.currentTarget.placeholder + " Is needed");
        checkoutBtn.classList.add('checkout-submit-red');
    }
}

let typingHandler=(event, props)=>{
    if(event.currentTarget.name == "cardNumber"){ /* If card input is being type*/
        let cursorPositionStart = event.target.selectionStart;/*Getting cursors Position Start*/
        let cursorPositionEnd = event.target.selectionEnd;/*Getting cursors Position End*/

        if(event.keyCode != 8 && event.keyCode != 37 && event.keyCode != 39 && event.currentTarget.value.length < 19){
            event.currentTarget.value = event.currentTarget.value.replace(/-/g, '');/* Replace hyphens for nothing */
            event.currentTarget.value = event.currentTarget.value.replace(/(\d{4})/g, '$1-');/*Replace Groups of 4 numbers to have a dash after them */

            if(event.currentTarget.value.charAt(cursorPositionStart).match(/^[\-]/)){ /* If the next character after the current cursor position is a hyphen*/
         
            event.target.selectionStart = cursorPositionStart+1; /*Moving cursors Position 1 character to the right */
            event.target.selectionEnd = cursorPositionEnd+1;/*Moving cursors Position End 1 character to the right */
            }
            else if (event.currentTarget.value.charAt(cursorPositionStart).match(/^[\d]/)){ /*If the next character after the current cursor position is a number */
                event.currentTarget.value = event.currentTarget.value.replace(/-/g, '');/* Replace hyphens for nothing */
                event.currentTarget.value = event.currentTarget.value.replace(/(\d{4})/g, '$1-');/*Replace Groups of 4 numbers to have a dash after them */
            }
            else{
                //console.log('Targets No hyphen ' + cursorPositionStart + " End -> " + cursorPositionEnd);
                event.target.selectionStart = cursorPositionStart; /*Moving cursors Position back to where it was before placing hyphen */
            event.target.selectionEnd = cursorPositionEnd; /*Moving cursors Position back to where it was before placing hyphen */
            }
    }
}
    if(event.currentTarget.name == "expDate" && event.currentTarget.value.length === 2 && event.keyCode != 8){
            event.currentTarget.value = event.currentTarget.value + "/";   
    }
}

let submissionHandler=(internalProp,props)=>{
    //console.log(PassedInput[0] + " " + PassedInput[1] + " " + PassedInput[2] + " " + PassedInput[3] + " " + PassedInput[4] + " " + PassedInput[5]);
    console.log(props.chosenPlan + "  current card is : " + props.currentCard);
    if(PassedInput[0]==true && PassedInput[1]==true && PassedInput[2]==true && PassedInput[3]==true && PassedInput[4]==true && PassedInput[5]==true){
        document.getElementById("checkout-form").submit();
    }
    else{
        props.stateChange("text", "Some information is missing or incorrect");
        document.getElementById("checkout-submit").classList.add('checkout-submit-red');
    }
}
const checkout =(props)=>{
    
    return(
        <div className="checkout">
            <div className="checkout-wrapper-left">
                <h2 className="checkout-left-title">Order Summary</h2>
                {props.planItems}
            </div>
            <div className="checkout-wrapper-right">
                <h2 className="checkout-wrapper-right-title">Complete Your Purchase</h2>
                <div className="checkout-wrapper-inner-right">

                    <form id="checkout-form" className="checkout-wrapper-right-form" action="payment_processor.php" method="POST">
                        <input className="checkout-form-hidden-input" name="planName" value={props.chosenPlan}></input>
                        <input className="checkout-form-hidden-input" name="cardType" value={props.currentCard}></input>
                        <input id="test" className="checkout-form-outside-input" type="email" name="email" required={true} onBlur={input =>{inputHandler(input, props)}} placeholder="Business email"></input>
                        <input className="checkout-form-outside-input" type="text" name="business" required={true} onBlur={input =>{inputHandler(input, props)}} placeholder="Business Name"></input>
                        <div className="checkout-form-card">
                            <input className="checkout-form-input" type="text" name="cardNumber" required={true} onChange={input => {props.logoHandler(input);}} onKeyUp={event => {typingHandler(event,props)}} onBlur={input =>{inputHandler(input, props)}} maxLength="19" placeholder="Card Number"></input>
                            <input className="checkout-form-input" type="text" name="cardName" required={true} onBlur={input =>{inputHandler(input, props)}} placeholder="Name On Card"></input>
                            <input className="checkout-form-input checkout-form-input-ccv" required={true} onBlur={input =>{inputHandler(input, props)}} type="text" name="ccv" placeholder="CCV" maxLength="4"></input>
                            <input className="checkout-form-input checkout-form-input-ccv" required={true} onKeyUp={event => {typingHandler(event,props)}} onBlur={input =>{inputHandler(input, props)}} type="text" name="expDate" placeholder="MM/YY" maxLength="5"></input>
                            <img className="checkout-form-cards-imgs" src={props.cardPicture}></img>
                        </div>
                        <div className="checkout-form-price-centering">
                            <div className="checkout-form-price-wrapper">
                                <input id="checkout-annual" className="checkout-form-price-input" name="price" type="radio" value={"$" + props.planPrice*12 + ".00"}></input>
                                <label className="checkout-form-price-input-label" for="checkout-annual">Yearly plan<br/>{"$" + props.planPrice*12 + ".00"}</label>
                            </div>
                            <div className="checkout-form-price-wrapper">
                                <input id="checkout-monthly" className="checkout-form-price-input" name="price" defaultChecked={true} type="radio" value={"$" + props.planPrice + ".00"}></input>
                                <label className="checkout-form-price-input-label" for="checkout-monthly">Monthly {"$" + props.planPrice + ".00"}</label>
                            </div>
                        </div>
                    </form>
                </div>
                <Link id="checkout-submit" className="checkout-links" onClick={input =>{submissionHandler(input, props)}}>{props.requiredText}</Link>
            </div>
            


        </div>
    );
}

export default checkout;

/*


{"correlation_id":"228.9090899583438",
"transaction_status":"declined",
"validation_status":"success",
"transaction_type":"purchase",
"transaction_tag":"4517553131",
"method":"credit_card",
"amount":"550200",
"currency":"USD",
"cvv2":"M",
"token":{
    "token_type":"FDToken",
    "token_data":{
        "value":"8857533936068568"
    }},
    "card":{
        "type":"Mastercard",
        "cardholder_name":"Expiry test",
        "card_number":"8568",
        "exp_date":"0121"
    },
        "bank_resp_code":"502",
        "bank_message":"Lost/Stolen",
        "gateway_resp_code":"00",
        "gateway_message":"Transaction Normal"} */